import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import { Container, Grid, Menu, MenuItem, Typography } from "@mui/material";
import { useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import TopBar from "../../../components/TopBar/TopBar";
import AdjustmentHistory from "./AdjustmentHistory";
import Main from "./Dashboard.js/Main";
import InventoryDashboard from "./InventoryDashboard";
import Location from "./Location";
import PurchaseInvoice from "./PurchaseInvoice";
import PurchaseOrders from "./PurchaseOrders";
import Service from "./Service";
import Stock from "./Stock";
import Main2 from "./StockDashboard.js/Main2";
import StockPendingTable from "./StockPendingTable";
import StockRequest from "./StockRequest";
import Supplier from "./Supplier";

const subTabsToShow = ["Stock", "Purchase", "Returns & Adjustments"];

const stockList = ["All Stock", "Low Stock", "Near Expiry", "Out of Stock"];
const purchaseList = ["Purchase Orders", "Purchase Invoice", "Pending to Add"];
const returnAndAdjustmentList = ["Adjustment History", "Pending Review"];

const Inventory = () => {
  const dispatch = useDispatch();
  const fetchRef = useRef(false);
  const [activeTab, setActiveTab] = useState("Dashboard");
  const [activeSubTab, setActiveSubTab] = useState(null);
  const [penTblVsble, setPenTblVsble] = useState(false);
  const { pendingStocks, selectedClinicBranch } = useSelector(
    (state) => state?.clinic,
  );
  const [anchorEl, setAnchorEl] = useState(null);
  const [serviceOption, setServiceOption] = useState("Service"); // Default
  const [stockOption, setStockOption] = useState("Stock"); // default
  // Define separate anchors
  const [serviceAnchorEl, setServiceAnchorEl] = useState(null);
  const [stockAnchorEl, setStockAnchorEl] = useState(null);
  const [masterAnchorEl, setMasterAnchorEl] = useState(null);
  const [reportAnchorEl, setReportAnchorEl] = useState(null);
  const [masterSubTab, setMasterSubTab] = useState("Location");
  const role = localStorage.getItem("role");

  // useEffect(() => {
  //   if (fetchRef.current) return;
  //   if (role === "ROLE_DOCTOR") {
  //     if (!selectedClinicBranch?.branchId) return;
  //     fetchRef.current = true;
  //     dispatch(
  //       getPendingStocksByClinic(
  //         `?type=pending&page=1&itemSize=10&clinicId=${selectedClinicBranch?.branchId}`,
  //       ),
  //     );
  //     return;
  //   }
  //   fetchRef.current = true;
  //   dispatch(getPendingStocksByClinic(`?type=pending&page=1&itemSize=10`));
  // }, [selectedClinicBranch, role, dispatch]);

  const handlePending = () => {
    setActiveTab("Stock");
    setPenTblVsble(true);
  };

  const getTabBasedSubList = (tab) => {
    if (!subTabsToShow.includes(tab)) return null;
    return tab === "Stock"
      ? stockList
      : tab === "Purchase"
        ? purchaseList
        : returnAndAdjustmentList;
  };

  const handleChangeTab = (tab) => {
    const subTabs = getTabBasedSubList(tab);
    setActiveTab(tab);
    setActiveSubTab(subTabs?.length > 0 ? subTabs?.[0] : null);
  };

  const onSubTabChange = (st) => {
    setActiveSubTab(st);
  };

  return (
    <>
      <TopBar>
        <Container maxWidth="xl">
          <div className="flex-row-ali-cen">
            <div
              className="ph10pv3"
              onClick={() => handleChangeTab("Dashboard")}
            >
              <div
                className={`flex-center cursor ${
                  activeTab === "Dashboard"
                    ? "pet-det-sel-tab"
                    : "pet-det-un-sel-tab"
                }`}
              >
                Dashboard
              </div>
            </div>
            <div className="ph10pv3" onClick={() => handleChangeTab("Stock")}>
              <div
                className={`flex-center cursor ${
                  activeTab === "Stock"
                    ? "pet-det-sel-tab"
                    : "pet-det-un-sel-tab"
                }`}
              >
                Stock
              </div>
            </div>
            <div className="ph10pv3" onClick={() => handleChangeTab("Service")}>
              <div
                className={`flex-center cursor ${
                  activeTab === "Service"
                    ? "pet-det-sel-tab"
                    : "pet-det-un-sel-tab"
                }`}
              >
                Service
              </div>
            </div>
            <div
              className="ph10pv3"
              onClick={() => handleChangeTab("Purchase")}
            >
              <div
                className={`flex-center cursor ${
                  activeTab === "Purchase"
                    ? "pet-det-sel-tab"
                    : "pet-det-un-sel-tab"
                }`}
              >
                Purchase
              </div>
            </div>
            <div
              className="ph10pv3"
              onClick={() => handleChangeTab("Request & Transfer")}
            >
              <div
                className={`flex-center cursor ${
                  activeTab === "Request & Transfer"
                    ? "pet-det-sel-tab"
                    : "pet-det-un-sel-tab"
                }`}
              >
                Request & Transfer
              </div>
            </div>
            <div
              className="ph10pv3"
              onClick={() => handleChangeTab("Returns & Adjustments")}
            >
              <div
                className={`flex-center cursor ${
                  activeTab === "Returns & Adjustments"
                    ? "pet-det-sel-tab"
                    : "pet-det-un-sel-tab"
                }`}
              >
                Returns & Adjustments
                {/* Refund & Adjustment */}
              </div>
            </div>
            <div>
              <div
                onMouseEnter={(e) => {
                  setReportAnchorEl(e.currentTarget);
                }}
                className={`flex-center cursor ${
                  activeTab === "Report"
                    ? "pet-det-sel-tab"
                    : "pet-det-un-sel-tab"
                }`}
              >
                Report <ArrowDropDownIcon fontSize="small" />
              </div>
              <Menu
                anchorEl={reportAnchorEl}
                open={Boolean(reportAnchorEl)}
                onClose={() => setReportAnchorEl(null)}
                MenuListProps={{
                  onMouseLeave: () => setReportAnchorEl(null),
                }}
              >
                <MenuItem
                  onClick={() => {
                    setActiveSubTab("Stock");
                    setActiveTab("Report");
                    setReportAnchorEl(null);
                  }}
                >
                  Stock
                </MenuItem>
                <MenuItem
                  onClick={() => {
                    setActiveSubTab("Service");
                    setActiveTab("Report");
                    setReportAnchorEl(null);
                  }}
                >
                  Service
                </MenuItem>
              </Menu>
            </div>
            <div>
              <div
                onMouseEnter={(e) => {
                  setMasterAnchorEl(e.currentTarget);
                }}
                className={`flex-center cursor ${
                  activeTab === "Master"
                    ? "pet-det-sel-tab"
                    : "pet-det-un-sel-tab"
                }`}
              >
                Master <ArrowDropDownIcon fontSize="small" />
              </div>
              <Menu
                anchorEl={masterAnchorEl}
                open={Boolean(masterAnchorEl)}
                onClose={() => setMasterAnchorEl(null)}
                MenuListProps={{
                  onMouseLeave: () => setMasterAnchorEl(null),
                }}
              >
                <MenuItem
                  onClick={() => {
                    setActiveSubTab("Location");
                    setActiveTab("Master");
                    setMasterAnchorEl(null);
                  }}
                >
                  Location
                </MenuItem>
                <MenuItem
                  onClick={() => {
                    setActiveSubTab("Supplier");
                    setActiveTab("Master");
                    setMasterAnchorEl(null);
                  }}
                >
                  Supplier
                </MenuItem>
              </Menu>
            </div>
          </div>

          {/* <Grid container spacing={2}>
            <Grid
              item
              xs={4}
              sm={4}
              md={2}
              lg={1.5}
              xl={1}
              onMouseEnter={(e) => {
                setStockAnchorEl(e.currentTarget);
              }}
              onMouseLeave={() => setStockAnchorEl(null)}
            >
              <Button
                text={
                  <span
                    style={{ display: "flex", alignItems: "center", gap: 4 }}
                  >
                    {stockOption}
                    <ArrowDropDownIcon
                      style={{ color: "gray", fontSize: 20 }}
                    />
                  </span>
                }
                tabSelectdBtn={activeTab === "Stock"}
                textBtn={activeTab !== "Stock"}
                color={AppColors.grayBtn2}
              />
              <Menu
                anchorEl={stockAnchorEl}
                open={Boolean(stockAnchorEl)}
                onClose={() => setStockAnchorEl(null)}
                MenuListProps={{
                  onMouseEnter: () => {},
                  onMouseLeave: () => setStockAnchorEl(null),
                }}
              >
                <MenuItem
                  onClick={() => {
                    setStockOption("Stock");
                    setActiveTab("Stock");
                    setStockAnchorEl(null);
                  }}
                >
                  Stock
                </MenuItem>
                <MenuItem
                  onClick={() => {
                    setStockOption("Dashboard");
                    setActiveTab("Stock");
                    setStockAnchorEl(null);
                  }}
                >
                  Dashboard
                </MenuItem>
                <MenuItem
                  onClick={() => {
                    setStockOption("Requests");
                    setActiveTab("Stock");
                    setStockAnchorEl(null);
                  }}
                >
                  Requests
                </MenuItem>
              </Menu>
            </Grid>
            <Grid
              item
              xs={4}
              sm={4}
              md={2}
              lg={1.5}
              xl={1}
              onMouseEnter={(e) => {
                setServiceAnchorEl(e.currentTarget);
              }}
              onMouseLeave={() => setServiceAnchorEl(null)}
            >
              <Button
                text={
                  <span
                    style={{ display: "flex", alignItems: "center", gap: 4 }}
                  >
                    {serviceOption}
                    <ArrowDropDownIcon
                      style={{ color: "gray", fontSize: 20 }}
                    />
                  </span>
                }
                tabSelectdBtn={activeTab === "Service"}
                textBtn={activeTab !== "Service"}
                color={AppColors.grayBtn2}
              />
              <Menu
                anchorEl={serviceAnchorEl}
                open={Boolean(serviceAnchorEl)}
                onClose={() => setServiceAnchorEl(null)}
                MenuListProps={{
                  onMouseEnter: () => {},
                  onMouseLeave: () => setServiceAnchorEl(null),
                }}
              >
                <MenuItem
                  onClick={() => {
                    setServiceOption("Service");
                    setActiveTab("Service");
                    setServiceAnchorEl(null);
                  }}
                >
                  Service
                </MenuItem>
                <MenuItem
                  onClick={() => {
                    setServiceOption("Dashboard");
                    setActiveTab("Service");
                    setServiceAnchorEl(null);
                  }}
                >
                  Dashboard
                </MenuItem>
              </Menu>
            </Grid>
            <Grid item xs={4} sm={4} md={2} lg={1.5} xl={1}>
              <div
                onMouseEnter={(e) => {
                  setMasterAnchorEl(e.currentTarget);
                }}
                className={`flex-center cursor ${
                  activeTab === "Master"
                    ? "pet-det-sel-tab"
                    : "pet-det-un-sel-tab"
                }`}
              >
                Master <ArrowDropDownIcon fontSize="small" />
              </div>
              <Menu
                anchorEl={masterAnchorEl}
                open={Boolean(masterAnchorEl)}
                onClose={() => setMasterAnchorEl(null)}
                MenuListProps={{
                  onMouseLeave: () => setMasterAnchorEl(null),
                }}
              >
                <MenuItem
                  onClick={() => {
                    setMasterSubTab("Location");
                    setActiveTab("Master");
                    setMasterAnchorEl(null);
                  }}
                >
                  Location
                </MenuItem>
                <MenuItem
                  onClick={() => {
                    setMasterSubTab("Supplier");
                    setActiveTab("Master");
                    setMasterAnchorEl(null);
                  }}
                >
                  Supplier
                </MenuItem>
              </Menu>
            </Grid>
            <Grid item xs={4} sm={4} md={2} lg={1.5} xl={1}>
              <Button
                text="Purchase History"
                tabSelectdBtn={activeTab === "Purchase History"}
                textBtn={activeTab !== "Purchase History"}
                color={AppColors.grayBtn2}
                onClick={() => setActiveTab("Purchase History")}
              />
            </Grid>
          </Grid> */}
        </Container>
        {/* <div className="pos-absolute r80 top65">
          <Typography
            className="fs14 txt-semi-bold orange-color cursor"
            onClick={handlePending}
          >
            Pending {pendingStocks?.totalRecords}
          </Typography>
        </div> */}
      </TopBar>
      {subTabsToShow?.includes(activeTab) ? (
        <Grid container spacing={0}>
          <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
            <div className="flex-row light-blue-back3 pv5 mh30">
              {getTabBasedSubList(activeTab)?.map((st, i) => (
                <div className="pos-rel">
                  <Typography
                    key={`${st}_${i}`}
                    className={`ml20 newTab ph10 cursor ${activeSubTab === st ? "newTabSelected blue-color" : ""}`}
                    onClick={() => onSubTabChange(st)}
                  >
                    {st}
                  </Typography>
                  {st === "Pending to Add" && (
                    <div className="red-back2 fs10 br10 img-wh20 pos-absolute white-color rhtMin5 topMin5 flex-center">
                      {pendingStocks?.totalRecords}
                    </div>
                  )}
                </div>
              ))}
            </div>
          </Grid>
        </Grid>
      ) : null}

      <div
        // className="mt20"
        style={{
          height: "calc(100vh - 130px)",
          overflowY: "auto",
          // paddingRight: "10px",
        }}
      >
        {activeTab === "Dashboard" ? (
          <InventoryDashboard
            setActiveTab={setActiveTab}
            setActiveSubTab={setActiveSubTab}
          />
        ) : null}
        {activeTab === "Stock" ? (
          <Stock
            penTblVsble={penTblVsble}
            setPenTblVsble={setPenTblVsble}
            activeSubTab={activeSubTab}
          />
        ) : null}
        {activeTab === "Service" ? <Service /> : null}
        {activeTab === "Purchase" ? (
          activeSubTab === "Purchase Orders" ? (
            <PurchaseOrders />
          ) : activeSubTab === "Purchase Invoice" ? (
            <PurchaseInvoice />
          ) : (
            <StockPendingTable setPenTblVsble={setPenTblVsble} />
          )
        ) : null}
        {activeTab === "Request & Transfer" ? <StockRequest /> : null}
        {activeTab === "Returns & Adjustments" ? (
          activeSubTab === "Adjustment History" ? (
            <AdjustmentHistory />
          ) : null
        ) : null}
        {activeTab === "Report" &&
          (activeSubTab === "Stock" ? (
            <Main2 />
          ) : activeSubTab === "Service" ? (
            <Main />
          ) : null)}
        {activeTab === "Master" &&
          (activeSubTab === "Location" ? (
            <Location />
          ) : activeSubTab === "Supplier" ? (
            <Supplier />
          ) : null)}
        {/* {activeTab === "Service" &&
          (serviceOption === "Service" ? <Service /> : <Main />)}
        {activeTab === "Stock" &&
          (stockOption === "Stock" ? (
            <Stock penTblVsble={penTblVsble} setPenTblVsble={setPenTblVsble} />
          ) : stockOption === "Requests" ? (
            <StockRequest />
          ) : (
            <Main2 />
          ))}        
        {activeTab === "Purchase History" ? <PurchaseHistory /> : null} */}
      </div>
    </>
  );
};

export default Inventory;
